import type { Action } from './types';

const action: Action = {
  action: 'CONNECT_CALENDAR',
  getHref: () => '/meetings?connect=true',
  getFollowUp: () => ({
    title: 'Connect your calendar',
    message:
      'Connect a Google or Outlook calendar. Afternoon will sync your meetings automatically.',
  }),
  completionEvents: ['CALENDAR_CONNECTED'],
};

export default action;
